import "../LoyaltyEditCreative/loyaltyEditCreative.scss";

import { useState } from "react";
import pluralize from "pluralize";
import { useSelector } from "react-redux";
import {
  getExcludeItemTermText,
  getExcludePaymentTermText,
} from "../../../utils";
import Typography from "../../../../../../../common/Typography";
import ExcludeItemsTerms from "../../ExcludeItems/ExcludeItemsTerms";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ExcludePaymentTerms from "../../ExcludePaymentMethod/ExcludePaymentTerms";

const LoyaltyFinalCreative = (props) => {
  const user = useSelector((state) => state?.auth?.user);
  const initData = useSelector((state) => state?.shortLink?.initData);
  const storeDets = useSelector((state) => state.store.businessDetails);
  const appLoyaltyData = useSelector((state) => state.loyalty?.loyaltyData); // for the protected routes in app

  const [isExcludeItemCollapse, toggleExcludeItemCollapse] = useState(
    props?.isCollapsedItemsTerm || false
  );

  const [isExcludePaymentCollapse, toggleExcludePaymentCollapse] = useState(
    props?.isCollapsedPaymentsTerm || false
  );

  const isShortlink = props?.isShortlink;
  const currPointsObj = props?.pointsObj;
  const shortlinkStoreName = props?.storeName;
  const previewRewards = props?.previewRewards; // * this will only come on loyalty/edit/review/{{storeId}} page
  const shortlinkLoyaltyData = props?.loyaltyData;

  const isShowLocks = isShortlink && currPointsObj?.current_points > 0;
  const storeName = isShortlink ? shortlinkStoreName : storeDets?.name;
  const loyaltyData = isShortlink ? shortlinkLoyaltyData : appLoyaltyData;
  const currencyView = isShortlink
    ? initData?.currency
    : user?.country?.currency_view;

  const loyaltyType = loyaltyData?.type;
  const pointsBranding = loyaltyData?.settings?.points_branding;
  const minBillAmnt = loyaltyData?.settings?.min_requirements?.bill_amount; // for earning cashback
  const minBillForRedeem = loyaltyData?.settings?.min_bill_for_redemption; // for redeeming cashback
  const isSameDayRedemption =
    loyaltyData?.settings?.earn_redeem_same_day?.active;
  const isMaxPointsSetting = loyaltyData?.settings?.max_points_earn;
  const isMaxPointsSettingActive = isMaxPointsSetting?.active;
  const maxPointsSettingValue = isMaxPointsSetting?.value;
  const isExcludePaymentSettingActive =
    loyaltyData?.exclude_payment_types?.is_active;

  const rewardsArr =
    previewRewards?.length > 0
      ? previewRewards
      : loyaltyData?.rewards?.filter((reward) => reward?.is_active);

  const currStoreExcludeItem = loyaltyData?.exclude_items;
  const excludeItemTermText = getExcludeItemTermText(pointsBranding);
  const excludePaymentTermText = getExcludePaymentTermText(loyaltyType);

  const showExcludeItemTerm =
    loyaltyData?.terms?.includes(excludeItemTermText) &&
    currStoreExcludeItem?.is_active;

  const showExcludePaymentTerm =
    loyaltyData?.terms?.includes(excludePaymentTermText) &&
    isExcludePaymentSettingActive;

  const handleExcludeItemCollapse = (e) => {
    e.stopPropagation();
    toggleExcludeItemCollapse(!isExcludeItemCollapse);
  };

  const handleExcludePaymentCollapse = (e) => {
    e.stopPropagation();
    toggleExcludePaymentCollapse(!isExcludePaymentCollapse);
  };

  return (
    <div className="loyalty-final-creative-card">
      <div
        className="preview-card"
        style={{
          backgroundColor: loyaltyData?.colors?.theme,
          borderBottom:
            loyaltyType === "cashback" ? "4px dashed #ffffff" : "none",
        }}
      >
        <div className="card-theme-step">
          <div className="card-header">
            <TransformWrapper
              disabled={true}
              initialScale={loyaltyData?.banner_position?.scale || 1}
              initialPositionX={loyaltyData?.banner_position?.position_x || 0}
              initialPositionY={loyaltyData?.banner_position?.position_y || 0}
            >
              <TransformComponent>
                <img
                  alt="banner_image"
                  title="banner image"
                  className="banner_image"
                  src={loyaltyData?.banner}
                />
              </TransformComponent>
            </TransformWrapper>
          </div>
          <div
            className="card-logo-div"
            style={{
              backgroundColor: loyaltyData?.colors?.text,
            }}
          >
            {loyaltyData?.logo ? (
              <img
                width="100px"
                alt="card-logo"
                title="Brand Logo"
                src={loyaltyData?.logo}
                className="card-logo-image"
              />
            ) : (
              <p
                style={{ color: loyaltyData?.colors?.theme }}
                className="card-logo-name"
              >
                {storeName}
              </p>
            )}
          </div>
        </div>
        <div className="card-content">
          <div className="title-content">
            <Typography
              weight="bold"
              customClass="loyalty-title"
              style={{ color: loyaltyData?.colors?.text }}
              size={loyaltyType === "cashback" ? "display-xl" : "display-lg"}
            >
              {loyaltyData?.title}
            </Typography>
            <Typography
              size="heading-lg"
              customClass="loyalty-description"
              style={{ color: loyaltyData?.colors?.text }}
            >
              {loyaltyData?.description}
            </Typography>
          </div>
          {loyaltyType === "cashback" ? (
            <>
              <div className="cashback-content">
                <Typography
                  size="text-xs"
                  style={{ color: loyaltyData?.colors?.text }}
                >
                  Earn
                </Typography>
                <Typography
                  weight="bold"
                  customClass="cashback-percentage"
                  style={{ color: loyaltyData?.colors?.text }}
                >
                  {loyaltyData?.points_earned}%
                </Typography>
                <Typography
                  weight="medium"
                  size="heading-lg"
                  style={{ color: loyaltyData?.colors?.text }}
                >
                  {pointsBranding?.active
                    ? pluralize(
                        pointsBranding?.name,
                        loyaltyData?.points_earned
                      )
                    : "Cashback"}{" "}
                  {!minBillAmnt?.active && "on every purchase"}
                </Typography>
                {minBillAmnt?.active && (
                  <Typography
                    size="text-xs"
                    weight="medium"
                    customClass="purchase-condition"
                    style={{ color: loyaltyData?.colors?.text }}
                  >
                    On min purchase of {currencyView}
                    {minBillAmnt?.amount}
                  </Typography>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="points-content">
                <Typography
                  size="text-md"
                  weight="medium"
                  className="points-earned-text"
                  style={{ color: loyaltyData?.colors?.text }}
                >
                  {(loyaltyType === "amount_spent" &&
                    `${currencyView}${loyaltyData?.amount_spent} Spent = ${
                      loyaltyData?.points_earned
                    } ${pluralize(
                      pointsBranding?.active ? pointsBranding?.name : "Point",
                      loyaltyData?.points_earned
                    )}`) ||
                    `${loyaltyData?.amount_spent} Visit = ${
                      loyaltyData?.points_earned
                    } ${pluralize(
                      pointsBranding?.active ? pointsBranding?.name : "Point",
                      loyaltyData?.points_earned
                    )}`}
                </Typography>
              </div>
              <div
                className={`rewards-div${
                  rewardsArr?.length > 5 ? " split-reward-design" : ""
                }`}
              >
                {rewardsArr
                  ?.sort((a, b) => a?.points_value - b?.points_value)
                  ?.map((reward, i) => (
                    <div
                      key={i}
                      className={`reward-row${
                        reward?.points_value > currPointsObj?.current_points
                          ? " cannot-redeem"
                          : ""
                      }${isShowLocks ? "" : " hide-locks"}`}
                      style={{
                        padding:
                          i === 0 && rewardsArr?.length < 6
                            ? "0 0 12px"
                            : "12px 0",
                      }}
                    >
                      <div className="left-side">
                        <Typography
                          weight="semibold"
                          size="display-lg"
                          style={{ color: loyaltyData?.colors?.text }}
                          customClass={`points${
                            reward?.points_value?.toString()?.length > 8
                              ? " short-text-for-points"
                              : ""
                          }`}
                        >
                          {reward?.points_value}
                        </Typography>
                        <Typography
                          size="text-xs"
                          customClass="points-branding"
                          style={{ color: loyaltyData?.colors?.text }}
                        >
                          {pluralize(
                            pointsBranding?.active
                              ? pointsBranding?.name
                              : "PTS",
                            reward?.points_value
                          )}
                        </Typography>
                      </div>
                      <div className="right-side">
                        <Typography
                          size={
                            reward?.name?.length > 60 ? "text-xs" : "text-md"
                          }
                          customClass="reward_name"
                          style={{ color: loyaltyData?.colors?.text }}
                        >
                          {reward?.name}
                        </Typography>
                        {reward?.settings?.min_bill?.is_active && (
                          <Typography
                            customClass="min_bill_for_redeeming_reward"
                            style={{ color: loyaltyData?.colors?.text }}
                          >
                            *Minimum purchase of {currencyView}
                            {reward?.settings?.min_bill?.value} required to
                            redeem reward.
                          </Typography>
                        )}
                      </div>
                      {isShowLocks && (
                        <img
                          alt="icon"
                          width="16px"
                          className="locked-icon"
                          src={
                            reward?.points_value > currPointsObj?.current_points
                              ? "/assets/images/qr/others/lock.svg"
                              : "/assets/images/qr/others/unlock-white.svg"
                          }
                        />
                      )}
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
        {loyaltyType !== "cashback" && (
          <div className="preview-footer">
            <Typography
              size="text-xs"
              weight="medium"
              customClass="term-header"
              style={{ color: loyaltyData?.colors?.text }}
            >
              Terms & Conditions
            </Typography>
            {isMaxPointsSettingActive && (
              <Typography
                customClass="term"
                style={{ color: loyaltyData?.colors?.text }}
              >
                *Earn upto {maxPointsSettingValue}{" "}
                {pluralize(
                  pointsBranding?.active ? pointsBranding?.name : "point",
                  maxPointsSettingValue
                )}{" "}
                on every purchase
              </Typography>
            )}
            {isSameDayRedemption && (
              <Typography
                customClass="term"
                style={{ color: loyaltyData?.colors?.text }}
              >
                *Loyalty{" "}
                {pluralize(
                  pointsBranding?.active ? pointsBranding?.name : "point",
                  2
                )}{" "}
                cannot be redeemed on the same day as the purchase made.
              </Typography>
            )}
            {loyaltyData?.terms?.join("")?.length > 0 ? (
              loyaltyData?.terms?.map((term, i) =>
                term?.length === 0 ||
                term === excludeItemTermText ||
                term === excludePaymentTermText ? (
                  <></>
                ) : (
                  <Typography
                    key={i}
                    customClass="term"
                    style={{ color: loyaltyData?.colors?.text }}
                  >
                    *{term}
                  </Typography>
                )
              )
            ) : (
              <Typography
                customClass="term"
                style={{ color: loyaltyData?.colors?.text }}
              >
                *Merchant reserves the right to final say.
              </Typography>
            )}
            {showExcludeItemTerm && (
              <ExcludeItemsTerms
                pointsBranding={pointsBranding}
                textColor={loyaltyData?.colors?.text}
                currStoreExcludeItem={currStoreExcludeItem}
                isExcludeItemCollapse={isExcludeItemCollapse}
                handleExcludeItemCollapse={handleExcludeItemCollapse}
              />
            )}
            {showExcludePaymentTerm && (
              <ExcludePaymentTerms
                loyaltyType={loyaltyType}
                textColor={loyaltyData?.colors?.text}
                excludedPaymentMethods={
                  loyaltyData?.exclude_payment_types?.list
                }
                isExcludePaymentCollapse={isExcludePaymentCollapse}
                handleExcludePaymentCollapse={handleExcludePaymentCollapse}
              />
            )}
          </div>
        )}
      </div>
      {loyaltyType === "cashback" && (
        <div className="cashback-terms">
          <Typography size="text-xs" weight="medium" customClass="term-info">
            Use your{" "}
            {pointsBranding?.active
              ? pluralize(pointsBranding?.name, loyaltyData?.points_earned)
              : "cashback"}{" "}
            to pay your next bill.
          </Typography>
          {pointsBranding?.active && (
            <Typography
              weight="medium"
              size="display-md"
              customClass="cashback-branding-info"
            >
              1 {pointsBranding?.name} = {currencyView}1
            </Typography>
          )}
          <div className="preview-footer">
            <Typography
              size="text-xs"
              weight="medium"
              customClass="term-header"
            >
              Terms & Conditions
            </Typography>
            {isMaxPointsSettingActive && (
              <Typography customClass="term">
                *Earn upto {!pointsBranding?.active ? `${currencyView} ` : ""}
                {maxPointsSettingValue}{" "}
                {pointsBranding?.active
                  ? pluralize(pointsBranding?.name, loyaltyData?.points_earned)
                  : ""}{" "}
                on every purchase
              </Typography>
            )}
            {isSameDayRedemption && (
              <Typography customClass="term">
                *Loyalty{" "}
                {pointsBranding?.active
                  ? pluralize(pointsBranding?.name, loyaltyData?.points_earned)
                  : "cashback"}{" "}
                cannot be redeemed on the same day.
              </Typography>
            )}
            {minBillForRedeem?.active && (
              <Typography customClass="term">
                *Minimum purchase of {currencyView}
                {minBillForRedeem?.amount} required to redeem{" "}
                {pointsBranding?.active
                  ? pluralize(pointsBranding?.name, loyaltyData?.points_earned)
                  : "cashback"}
                .
              </Typography>
            )}
            {loyaltyData?.terms?.join("")?.length > 0 ? (
              loyaltyData?.terms?.map((term, i) =>
                term?.length === 0 ||
                term === excludeItemTermText ||
                term === excludePaymentTermText ? (
                  <></>
                ) : (
                  <Typography customClass="term" key={i}>
                    *{term}
                  </Typography>
                )
              )
            ) : (
              <Typography customClass="term">
                *Merchant reserves the right to final say.
              </Typography>
            )}
            {showExcludeItemTerm && (
              <ExcludeItemsTerms
                textColor={"#0e1b1b"}
                currStoreExcludeItem={currStoreExcludeItem}
                isExcludeItemCollapse={isExcludeItemCollapse}
                handleExcludeItemCollapse={handleExcludeItemCollapse}
              />
            )}
            {showExcludePaymentTerm && (
              <ExcludePaymentTerms
                textColor={"#0e1b1b"}
                loyaltyType={loyaltyType}
                excludedPaymentMethods={
                  loyaltyData?.exclude_payment_types?.list
                }
                isExcludePaymentCollapse={isExcludePaymentCollapse}
                handleExcludePaymentCollapse={handleExcludePaymentCollapse}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoyaltyFinalCreative;
